























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class NuxStepMedia extends Vue {
  @Prop() videoPoster: string | undefined;

  @Prop() videoSrc: string | undefined;

  @Prop() imageSrc: string | undefined;

  get hasImage(): boolean {
    return this.imageSrc !== undefined;
  }

  get hasVideo(): boolean {
    return this.videoSrc !== undefined;
  }
}
